import DraggableSailingDateWidget from './DraggableSailingDateWidget';
import {
  SailingDateWidgetHotspot,
  generateSailingDateWidgetArea,
} from './SailingDateWidgetHotspot';
import { WidgetBase } from '@go-shared/types/feedTemplate';
import { getWidgetHTML } from '@go-shared/lib/feed';
import { BaseFeedEditorHotspotProps, BaseDraggableSourceProps } from '@go-client/lib/feedEditor';

export const SailingDateWidget: WidgetBase<BaseFeedEditorHotspotProps, BaseDraggableSourceProps> = {
  hotspot: SailingDateWidgetHotspot,
  draggable: DraggableSailingDateWidget,
  getHTML: getWidgetHTML,
  getArea: generateSailingDateWidgetArea,
};
